export default "__VITE_ASSET__v2OIYeQU__"